



























































































































import Vue from 'vue';
import axios from "axios";

export default Vue.extend({
  name: 'app',
  methods: {
    loggedIn() {
      return axios.defaults.headers.common["Authorization"];
    }
  }
});
